import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { FieldActionEvent } from '../dynamic-field.component';
import { Tag } from '../../document-details.dto';

@Component({
  selector: 'app-tags-field',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './tags-field.component.html',
  styleUrl: './tags-field.component.scss'
})
export class TagsFieldComponent {
  
  @Input() field: any;
  @Input() formGroup!: FormGroup;
  @Input() tags: Tag[] = [];
  @Input() hasFullAccess = false;
  @Input() canEdit = false;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();

  get tagsControl() {
    return this.formGroup.get('tags');
  }

  get selectedTags(): Tag[] {
    const value = this.tagsControl?.value;
    return Array.isArray(value) ? value : [];
  }

  get isDisabled(): boolean {
    return !this.hasFullAccess && !this.canEdit;
  }

  onAddTag(tag: any) {
    this.actionEmit.emit({ action: 'addTag', data: tag });
  }

  onRemoveTag(tag: any) {
    this.actionEmit.emit({ action: 'removeTag', data: tag });
  }

  onTagsModelChange(tags: Tag[]): void {
    const normalizedTags = Array.isArray(tags) ? tags : [];
    this.tagsControl?.setValue(normalizedTags, { emitEvent: false });
  }
}
